function setDataLoading({ state }) {
  state.set('app.data.loading', true)
}

export default setDataLoading



// WEBPACK FOOTER //
// ./src/modules/user/actions/setDataLoading.js